export default __webpack_public_path__ + "static/casablanca-1-14bf89c1bf825fb938a5f8a7d3d4637a.jpg";